import {
	EmbedTestHost,
	EmbedTestSkeleton,
} from "@commerce/install/EmbedTestHost";
import {
	embedTestSearchSchema,
	embedTestTargetsQuery,
} from "@commerce/install/embed-test-meta";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { getSessionFn } from "~/server/auth";

/**
 * Embed test host (ADR-5): opens a retailer's chat as an app's iframe or a website's widget
 * would, and logs every bridge event. Retailer admins see their retailers; platform admins
 * see all of them (embedSettings.test.targets decides).
 */
export const Route = createFileRoute("/embed-test")({
	validateSearch: embedTestSearchSchema,
	beforeLoad: async ({ location }) => {
		const session = await getSessionFn();
		if (!session?.user) {
			throw redirect({
				to: "/login",
				search: { redirectTo: location.href },
			});
		}
	},
	loader: async () => {
		const queryClient = getServerQueryClient();
		await queryClient.ensureQueryData(embedTestTargetsQuery());
		return { dehydratedState: dehydrateForLoader(queryClient) };
	},
	head: () => ({ meta: [{ title: `Embed test host - ${config.appName}` }] }),
	component: EmbedTestPage,
});

function EmbedTestPage() {
	const { dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={<EmbedTestSkeleton />}
			dehydratedState={dehydratedState}
			errorFallback="inline"
		>
			<EmbedTestHost />
		</AsyncBoundary>
	);
}
